import { autoinject, transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { ValidationController } from "aurelia-validation";
import { CustomValidationRenderer } from "../../../../../../client-validation-system/custom-validation-renderer";
import { PortTerminalAndBerthResponse } from "../../models/ports-and-terminals.models";
import { PartialAddManualVesselSchedule } from "./partial-add-manual-vessel-schedule/partial-add-manual-vessel-schedule";
import { PartialUploadVesselList } from "./partial-upload-vessel-list/partial-upload-vessel-list";

@autoinject
@transient()
export class AddVesselToScheduleDialog {

    //Is the main 'addVesselTypeView' showing
    public addVesselTypeViewShowing: boolean = true;
    public model: AddVesselToScheduleDialogModel;
    public currentVM: IPartialAddVesselSchedule;

    constructor(private dialogClientService: DialogClientService, private validationController: ValidationController,
        private addManualVesselScheduleVM: PartialAddManualVesselSchedule, private uploadVesselListVM: PartialUploadVesselList) {
        this.validationController.reset();
        this.validationController.addRenderer(new CustomValidationRenderer());
    }

    /**
     * Close the form dialog
     */
    close() {
        if(this.currentVM?.dispose)
            this.currentVM.dispose();
        this.currentVM = null;
        this.dialogClientService.hide();
        this.addVesselTypeViewShowing = true;
    }

    /**
     * Close current VM and go back to main view
     */
    goBack() {
        if(this.currentVM?.dispose)
            this.currentVM.dispose();
        this.currentVM = null;
        this.addVesselTypeViewShowing = true;
    }

    activate(model: AddVesselToScheduleDialogModel){
        this.model = model;
    }

    addVesselType(x: number) {
        if(x == 1) { //Upload vessel list
            this.addVesselTypeViewShowing = false;
            this.currentVM = this.uploadVesselListVM;
        }
        else if(x == 2){ //Add manually
            this.addVesselTypeViewShowing = false;
            this.currentVM = this.addManualVesselScheduleVM;
        }
    }

    submit()
    {
        return new Promise<void>((resolve, reject) => { 
            if(!this.currentVM || !this.currentVM.submit) return;

            this.currentVM.submit().then(() => {
                resolve();
                this.dialogClientService.hide();
            }).catch(e => {
                reject(e);
            });
        });
    }
}

export interface AddVesselToScheduleDialogModel
{
    portTerminalAndBerthResponse: PortTerminalAndBerthResponse;
    onSave: () => void;
    showETD?: boolean;
}

export interface IPartialAddVesselSchedule
{
    submit(): Promise<void>;
    dispose(): void;
    canSubmit: boolean;
}